<section class="sh-dialog__content">
  @if (config.data.message) {
    <p class="sh-preserve-linebreaks">{{config.data.message}}</p>
  }
  <label for="label-input">{{config.data.batchTagDialogMessage}}</label>
  <input id="label-input" type="text" [(ngModel)]="batchTag" class="sh-input-field" />
</section>
<footer class="sh-dialog__footer">
  <div class="sh-action-group -sh-align-end">
    @if (config.data.yes) {
      <button type="button" class="sh-button sh-action-group__item" (click)="yes()">{{ config.data.yes }}</button>
    }
    @if (config.data.no) {
      <button type="button" class="sh-button--secondary sh-action-group__item" (click)="no()">{{ config.data.no }}</button>
    }
  </div>
</footer>
